module.exports = __webpack_public_path__ + "img/people-trans-gimpshit.4a7deabe.png";